import {
    Box,
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../components/base/BasicDialog/BasicDialog";
import { SnackbarError } from "../../components/base/SnackbarAlert/SnackbarError";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import {
    useAgreementCancellationReasons,
    useCancelAgreement,
} from "../../services/agreementsService";
import { useLocalizedProperty } from "../../utils"
import { useDialogBetter } from "../../hooks/useDialogBetter";
import ConfirmationDialog from "../../components/dialog/ConfirmationDialog/confirmationDialog";

export const AgreementCancellationDialog = ({ open, onClose, agreementId, agreementPaymentPaidAmount ,onSuccess }) => {
    const { t } = useTranslation();
    const [selectedReasonId, setSelectedReasonId] = useState("");
    const [resonNote, setReasonNote] = useState("");
    const [error, setError] = useState("");

    const getLocalizedProperty = useLocalizedProperty();

    const { data: cancellationReasons, isLoading: isLoadingReasons } =
        useAgreementCancellationReasons({
            enabled: open,
        });

    const { mutate: cancelAgreement, isPending: isCancelling } = useCancelAgreement({
        onSuccess: () => {
            onClose();
            onSuccess?.();
            toast.custom(
                () => (
                    <SnackbarSuccess message={t("agreements.cancellationDialog.successMessage")} />
                ),
                {
                    position: "bottom-right",
                },
            );
        },
        onError: (error) => {
            console.error("Error cancelling agreement:", error);
            toast.custom(
                () => <SnackbarError message={t("agreements.cancellationDialog.errorMessage")} />,
                {
                    position: "bottom-right",
                },
            );
        },
    });

    const {
        openDialog: openReturnReservationPaymentDialog,
        closeDialog: closeReturnReservationPaymentDialog,
    } = useDialogBetter();

    const handleOpenReturnReservationPaymentDialog =()=> openReturnReservationPaymentDialog({
            Component: ConfirmationDialog,
            componentProps: {
            title: t("bankings.returnReservationPaymentDialogTitle"),
            onYes: () => {
                closeReturnReservationPaymentDialog()
                cancelAgreement({ agreementId, reasonId: selectedReasonId, resonNote: resonNote, returnReservationPayment: true })
            },
            onNo: () => {
                closeReturnReservationPaymentDialog()
                cancelAgreement({ agreementId, reasonId: selectedReasonId, resonNote: resonNote, returnReservationPayment: false })
            },
            onCancel: () => {
                closeReturnReservationPaymentDialog()
            },
            content: `${t("bankings.returnReservationPaymentDialogContentOne")} ${agreementPaymentPaidAmount} zł. ${t("bankings.returnReservationPaymentDialogContentTwo")}`, 
            showCancelButton: true,
            showCloseButton: true,
            },
        })

    const handleChangeReason = (event) => {
        setSelectedReasonId(event.target.value);
        setReasonNote("")
        setError("");
    };

    const handleCancel = () => {
        if (!selectedReasonId) {
            setError(t("agreements.cancellationDialog.reasonRequired"));
            return;
        }

        if (agreementPaymentPaidAmount && agreementPaymentPaidAmount > 0){
            handleOpenReturnReservationPaymentDialog()
            
        } else {
            cancelAgreement({ agreementId, reasonId: selectedReasonId, resonNote: resonNote, returnReservationPayment: null })
        }
    };


    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            title={t("agreements.cancellationDialog.title")}
            maxWidth="sm"
            showBottomCloseButton={false}
            showDialogActions={false}
        >
            <Box sx={{ p: 2 }}>
                <FormControl fullWidth error={!!error} disabled={isLoadingReasons || isCancelling}>
                    <InputLabel id="agreement-cancellation-reason-label">
                        {t("agreements.cancellationDialog.reasonLabel")}
                    </InputLabel>
                    <Select
                        labelId="agreement-cancellation-reason-label"
                        value={selectedReasonId}
                        label={t("agreements.cancellationDialog.reasonLabel")}
                        onChange={handleChangeReason}
                    >
                        {cancellationReasons?.map((reason) => (
                            <MenuItem key={reason.id} value={reason.id}>
                                {getLocalizedProperty(reason, "reason_name")}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && <FormHelperText>{error}</FormHelperText>}
                    <TextField
                        sx={{marginTop: 2}}
                        labelId="agreement-fiasco-reason-note_label"
                        value={resonNote}
                        multiline
                        rows={2}
                        label={t("agreements.cancellationDialog.reasonNoteLabel")}
                        onChange={(e)=>setReasonNote(e.target.value)}
                    />
                </FormControl>

                <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}>
                    <Button variant="outlined" onClick={onClose} disabled={isCancelling} fullWidth>
                        {t("agreements.cancellationDialog.cancel")}
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleCancel}
                        disabled={isLoadingReasons || isCancelling}
                        fullWidth
                    >
                        {t("agreements.cancellationDialog.confirmButton")}
                    </Button>
                </Box>
            </Box>
        </BasicDialog>
    );
};
